import { BaseInput, BaseInputProps } from "../primitive/BaseInput"

export interface NumberInputProps extends Omit<BaseInputProps, "type"> {
    value: number;
    onValueChange: (newValue: number) => void;
}

export const NumberInput = (props: NumberInputProps) => {
    return (
        <BaseInput
            type="number"
            {...props}
            onValueChange={(val: string) => props.onValueChange(Number(val))}
        />
    )
}